var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4033 11.2354C7.99628 10.1056 9.72533 9.36087 10.5905 9.00103C13.0606 7.97361 13.5739 7.79514 13.9084 7.78925C13.982 7.78795 14.1465 7.80619 14.2531 7.89266C14.3431 7.96568 14.3678 8.06431 14.3797 8.13354C14.3915 8.20276 14.4063 8.36047 14.3946 8.48369C14.2607 9.89014 13.6815 13.3032 13.3868 14.8785C13.2622 15.545 13.0166 15.7685 12.779 15.7904C12.2624 15.8379 11.8702 15.449 11.3699 15.1211C10.5871 14.6079 10.1448 14.2885 9.38494 13.7877C8.50676 13.209 9.07605 12.891 9.57652 12.3711C9.70749 12.2351 11.9833 10.1651 12.0274 9.97727C12.0329 9.95379 12.038 9.86624 11.986 9.82002C11.934 9.77379 11.8572 9.7896 11.8018 9.80217C11.7233 9.81999 10.4727 10.6466 8.05002 12.282C7.69504 12.5257 7.37351 12.6445 7.08543 12.6383C6.76784 12.6314 6.15694 12.4587 5.70279 12.3111C5.14576 12.13 4.70305 12.0343 4.7416 11.7268C4.76168 11.5666 4.98225 11.4028 5.4033 11.2354Z",
    fill: "#ced3df"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.693359,
    y: 1.45056,
    width: 19.3609,
    height: 19.3609,
    rx: 9.68044,
    stroke: "#ced3df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.502e345c600d8e368b1238e8e8a7e9d0.svg";
export { ForwardRef as ReactComponent };